import { useContext } from "react";

import AppRoleContext from "context/AppRoleContext";
import { isBuilderAdmin, isSystemAdmin } from "core/utils/roleUtils";
import SystemAdinSettings from "./SystemAdminSettings";
import BuilderSettings from "./builderSettings/BuilderSettings";
import { Typography } from "@mui/material";

export const AppSettings = () => {
  const appRoleDetails = useContext(AppRoleContext);
  if (isSystemAdmin(appRoleDetails)) {
    return <SystemAdinSettings />;
  }
  if (isBuilderAdmin(appRoleDetails)) {
    return <BuilderSettings />;
  }
  return (
    <>
      <Typography className="h2">
        <strong>No Settings Found</strong>
      </Typography>
    </>
  );
};
export default AppSettings;
